/* eslint-disable consistent-this */
/* eslint-disable no-invalid-this */
/* eslint-disable no-magic-numbers */

/* global jQuery */

import { allFocusOut, focusFirstTabbableElement } from '../helpers'

// ------   Popover Modals Module   --------- /
// ------------------------------------------ /

export default function PSJPopoverModals( className, jsClassName, onLaunch, onClose ) {

	var self = this

	this.parentToDelegateEvents = jQuery( 'body' )

	this.trigger = ''
	this.closer = ''

	this.currentModal = ''
	this.currentTrigger = ''
	this.isActive = false

	this.className = className
	this.jsClassName = jsClassName
	this.modalObject = ''

	this.onLaunch = onLaunch
	this.onClose = onClose

	this.events = function() {

		// Clicking on trigger
		self.parentToDelegateEvents.on(
			'click',
			self.trigger,
			function() {
				self.triggerLaunch( jQuery( this ) )
			}
		);

		// Clicking outside of box but inside of modal
		self.modalObject.on( 'click', function( event ) {

			const box = self.currentModal.find( '.' + self.className + '__box' )
			const isTarget = box.is( event.target )
			const hasTarget = box.has( event.target ).length

			if ( ! isTarget && ! hasTarget ) {
				self.closeModal()
			}
		});

		// Clicking on close button
		self.parentToDelegateEvents.on(
			'click',
			self.closer,
			function() {
				self.closeModal()
			}
		);

		// Prevent tabbing out of active modal

		allFocusOut( self.modalObject )

		self.modalObject.on( 'allfocusout', function() {
			if ( self.isActive ) {
				focusFirstTabbableElement( self.currentModal );
			}
		});
	};

	this.init = function() {

		// Define triggering element
		self.trigger = '.' + self.jsClassName + '__trigger'

		// Define closing element
		self.closer = '.' + self.jsClassName + '__closer'

		// Define PSJ modal object
		self.modalObject = jQuery( '.' + self.className )

		self.events()
	};

	this.triggerLaunch = function(trigger) {

		// Set trigger
		self.setTrigger( trigger );

		// Compute modal
		// const modal = jQuery(trigger.data('popover-modal'));
		const modal = jQuery( '.' + self.className ).eq( 0 )

		// Launch it
		self.launch( modal );
	};

	this.setTrigger = function( trigger ) {
		self.currentTrigger = trigger;
	};

	this.launch = function( modal ) {

		// Update vars
		self.currentModal = modal
		self.isActive = true

		// Display modal on DOM
		self.currentModal.addClass( 'is-active' )

		// Give HTML the overflow class
		jQuery( 'html, body' ).addClass( 'has-no-overflow' )

		// Initialize ESC key listener
		jQuery( document ).on( 'keydown.modalESCKeydown', function( event ) {
			if ( event.keyCode && event.keyCode === 27 ) {
				self.closeModal()
			}
		});

		// Focus first tabbable element in modal
		window.setTimeout( function() {
			focusFirstTabbableElement( self.currentModal )
		}, 0 )

		// Load any iframes from their data-src attributes
		const iframes = self.currentModal.find( 'iframe' )

		iframes.each( function( index, iframeElement ) {
			iframeElement.setAttribute( 'src', iframeElement.dataset.src )
		} );

		// Execute onLaunch function
		if ( self.onLaunch && typeof self.onLaunch === 'function' ) {
			self.onLaunch.call( self.currentModal, self.currentModal );
		}

		modal.trigger( 'popovermodallaunch' );
	};

	this.injectModalTitle = function( modal, title ) {

		// Find the box and inject it
		modal.find( '.' + self.className + '__title' ).html( title );
	};

	this.injectModal = function( modal, content ) {

		// Find the box and inject it
		modal.find( '.' + self.className + '__content' ).html( content );
	};

	this.closeModal = function() {

		// Update vars
		self.isActive = false;

		// Hide modal on DOM
		self.currentModal.removeClass( 'is-active' );

		// Remove overflow class from HTML
		jQuery( 'html, body' ).removeClass( 'has-no-overflow' );

		// Remove ESC key listener
		jQuery( document ).off( 'keydown.modalESCKeydown' );

		// Return focus to current trigger
		window.setTimeout( function() {
			focusFirstTabbableElement( self.currentTrigger, '', true )
		}, 0 )

		// Find and stop any child AV elements
		const av = self.currentModal.find( 'audio, video' )

		av.each( function( index, avElement ) {
			avElement.pause()
		} );

		// Remove iFrame src attributes
		const iframes = self.currentModal.find( 'iframe' )

		iframes.each( function( index, iframeElement ) {
			iframeElement.removeAttribute( 'src' )
		} );

		// Execute custom onClose function
		if ( self.onClose && typeof self.onClose === 'function' ) {
			self.onClose.call( self.currentModal, self.currentModal )
		}

		self.currentModal.trigger( 'popovermodalclose' )
	};
}
